export const navLinks = [
  { label: "About", href: "#about" },
  { label: "Projects", href: "#projects" },
  { label: "Experience", href: "#experience" },
  { label: "Contact", href: "#contact" },
];

export const marqueeItems = [
  "React",
  "TypeScript",
  "Next.js",
  "Frontend Architecture",
  "Performance",
  "Scalability",
  "Design Systems",
  "Accessibility",
  "Testing",
  "UI/UX",
  "SSR",
  "Component Systems",
  "Artificial Intelligence",
];

const CAREER_START_YEAR = 2019;

export const stats = [
  {
    value: `${new Date().getFullYear() - CAREER_START_YEAR}+`,
    label: "Years experience",
  },
  { value: "20+", label: "Projects shipped" },
  { value: "∞", label: "Bugs squashed" },
  { value: "1", label: "Coffee / hour" },
];

export const skills = [
  {
    label: "Languages & Frameworks",
    items: ["TypeScript", "JavaScript", "Next.js", "React", "Angular"],
  },
  {
    label: "Styling & UI",
    items: [
      "MUI",
      "Tailwind",
      "Ant Design",
      "Bootstrap",
      "Sass",
      "CSS Modules",
    ],
  },
  {
    label: "Tooling & Practices",
    items: [
      "Jest",
      "Storybook",
      "CI/CD",
      "Azure DevOps",
      "Performance Optimization",
      "Accessibility (A11Y)",
      "SSR",
    ],
  },
  {
    label: "Design & Collaboration",
    items: [
      "Figma",
      "Design Systems",
      "Cross-Functional Collaboration",
      "Agile / Scrum",
    ],
  },
  {
    label: "Guilty Pleasures",
    items: [
      '"Approved with suggestions"',
      "Spacing Perfectionism",
      "Overthinking Component Names",
      "Performance Rabbit Holes",
      "Turning Simple Refactors Into Architecture Discussions",
    ],
  },
];

export const projects = [
  {
    number: "001",
    title: "TicketNetwork",
    description:
      "Contributing to a leading online ticket marketplace connecting users to 100,000+ live events worldwide. Building and optimizing modern Next.js/React experiences across event discovery and checkout flows, with a strong focus on performance, scalability, reusable architecture and UI/UX improvements.",
    tech: ["Next.js", "Redux", "Material UI", "Jest"],
    featured: true,
    href: "mailto:xhonatanhajdari@gmail.com",
  },
  {
    number: "002",
    title: "Go Teacher",
    description:
      "Engineered a Chrome extension and classroom management platform integrated with Google Classroom, enabling streamlined communication, content distribution and student engagement tracking for educators at scale.",
    tech: ["React", "Redux", "Node.js", "Tailwind", "Jest"],
    href: "mailto:xhonatanhajdari@gmail.com",
  },
  {
    number: "003",
    title: "Neos Air",
    description:
      "Developed enterprise-grade booking and checkout experiences for an international airline platform, building responsive multi-step flows and optimizing complex user journeys across web applications.",
    tech: ["React", "Next.js", "Redux", "Material UI"],
    href: "mailto:xhonatanhajdari@gmail.com",
  },
  {
    number: "004",
    title: "Almaviva",
    description:
      "Contributed to large-scale enterprise platforms and digital transformation initiatives by building and modernizing internal dashboards, enterprise systems and frontend workflows across React and Angular ecosystems.",
    tech: ["Angular", "React", "TypeScript", "Ant Design"],
    href: "mailto:xhonatanhajdari@gmail.com",
  },
  {
    number: "005",
    title: "Get Joy Food",
    description:
      "Built and customized frontend experiences for a Shopify-based e-commerce platform focused on pet wellness and nutrition, combining React with Shopify's Liquid framework to deliver modern and performant shopping experiences.",
    tech: ["React", "Liquid", "TypeScript", "Redux", "Shopify"],
    href: "mailto:xhonatanhajdari@gmail.com",
  },
];

export const experienceItems = [
  {
    period: "2024 — Present",
    company: "TicketNetwork",
    role: "Senior Frontend Engineer",
    description:
      "Driving FE engineering for a large-scale marketplace platform, with a strong focus on scalability, performance and modern architecture. I design and maintain scalable component systems, collaborate closely with design and backend teams, and help shape the frontend technical direction across the platform. I've introduced performance optimization initiatives, modern testing practices with AI+Jest and delivered complex, high-impact features used by a large user base, while taking full ownership of frontend quality, maintainability and overall user experience.",
  },
  {
    period: "2022 — 2024",
    company: "Freelance",
    role: "Senior Frontend Engineer",
    description:
      "I led the development of sophisticated React applications, designing scalable component architectures and state management solutions to support complex business needs. Alongside development, I mentored junior developers and fostered a collaborative, knowledge-sharing environment within the team. I also focused on creating responsive, user-centered experiences across both web and mobile platforms, balancing usability, performance and clean design.",
  },
  {
    period: "2020 — 2023",
    company: "Ritech Group of Companies",
    role: "Frontend Engineer",
    description:
      "I started my career building interactive/modern web applications, where I developed a strong foundation in HTML, CSS, JavaScript and responsive design while delivering projects for international clients. Over the years, grown into building scalable and user-focused FE applications using React and TypeScript, with a strong focus on clean architecture, performance and maintainability. I enjoyed turning complex ideas into intuitive user experiences, translating Figma designs into polished interfaces and working closely with teams to deliver high-quality products. Along the way, gained extensive experience with tools and technologies such as Redux, Context API, Tailwind CSS, Bootstrap and Sass, always aiming to create applications that are both visually engaging and technically solid.",
  },
];

export const contactLinks = [
  {
    label: "Email me",
    href: "mailto:xhonatanhajdari@gmail.com",
    icon: "email",
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/xhonatan-hajdari",
    icon: "linkedin",
    external: true,
  },
];
